import React from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

function StayUpdated() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="container-fluid bg-primary text-secondary p-5">
      <div className="row g-5">
        <div className="col-12 text-center">
          <h1 className="mb-4 oz-title">{t("stay_update")}</h1>
          <form className="mx-auto" style={{ maxWidth: "600px" }}>
            <div className="input-group">
              <input
                type="text"
                className="form-control border-white p-3"
                placeholder="Your Email"
              />
              <button
                onClick={() => navigate("/book")}
                className="btn btn-dark px-4 oz-btn"
              >
                {t("register")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default StayUpdated;
